export enum SocialLinks {
  DISCORD = 'https://discord.com/invite/GjpYfqZj7H',
  TELEGRAM = 'https://t.me/gamecreditsglobal/',
  TWITTER = 'https://twitter.com/gamecredits/',
  GITHUB = 'https://github.com/genesis-worlds/',
  GOVERNANCE = 'https://hub.genesis.game/',
  WHITEPAPER = 'https://docs.genesis.game/genesis-worlds-metaverse/general-information/genesis-worlds-whitepaper',
  DOCS = 'https://docs.genesis.game/',
}
